<template>
    <div class="layout-login flex h-full flex-col justify-center bg-zinc-50">
        <layout-contained>
            <div class="mx-auto w-full overflow-hidden rounded-md bg-white shadow-2xl sm:max-w-lg">
                <div class="bg-zinc-800 p-5 text-xl font-medium text-white shadow-md">
                    Login to {{ $config.public.companyName }}
                </div>
                <div>
                    <div class="px-5 pb-4 pt-6" v-show="!loading">
                        <slot></slot>
                        <alert-error class="mt-3" :alert="error"></alert-error>
                        <div class="flex flex-row" v-if="showRestartLogin">
                            <div class="flex grow"></div>
                            <button-regular
                                class="mt-5"
                                buttonText="Try Again"
                                :buttonClick="restartLogin"
                            ></button-regular>
                        </div>
                    </div>
                    <loading-widget v-show="loading"></loading-widget>
                </div>
            </div>
        </layout-contained>
    </div>
</template>

<script>
import {mapState} from 'pinia';

export default {
    name: 'LayoutLogin',
    props: ['loading', 'error', 'restartLogin'],
    computed: {
        ...mapState(useStoreLogin, {
            showRestartLogin: 'showRestartLogin',
        }),
    },
};
</script>
